module.exports = __webpack_public_path__ + "media/icons/paliwo-title-blue@3x-f5ed444b.svg";